<template>
  <div>
    <b-alert show variant="info">
      <i class="fas fa-info-circle fa-lg mr-2" />
      <b v-text="this.$lang.surveyLang.survey_group_parvandeh_list_alert" />
    </b-alert>
    <Search
      :title="$lang.surveyLang.survey_group_parvandeh_list"
      :allowFields="$lang.surveyLang.survey_group_parvandeh_fields"
      :hiddenFields="hiddenFields"
      :url="url"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      routeName="survey_group_edit"
      removeModalSize="lg"
      :defaultViewCount="10"
      :dynamicButtons="dynamicButtons"
      :extraButtons="extraButtons"
      primaryKey="id"
      ref="parvandeh"
      @getPermisson="updatePermissions"
      :visibleAdd="isAdmin(parentPermissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <RegisterParvandehFrom
          :parentPermissions="parentPermissions"
          @close="search.close"
          @getData="getData"
        />
      </template>
    </Search>

    <Modal
      :show="isImportSurvayGroupModal"
      :title="$lang.commenterUpload"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
    >
      <template #body>
        <ResourceUploader
          :url="survayGroupImportUploadUrl"
          :label="$lang.attachFile"
          :hasEditTitle="true"
          :cancelButton="true"
          exampleFileName="import_survay_group_parvandeh"
          uploaderName="survey_group_parvandeh_import"
          @onSuccessUpload="handleCloseSurvayGroupImportModal"
          @close="handleCloseSurvayGroupImportModal"
        />
      </template>
    </Modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import RegisterParvandehFrom from "../forms/registerParvandehFrom.vue";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";
import { Modal, ResourceUploader } from "@/components/re-design";

export default {
  components: {
    Search,
    RegisterParvandehFrom,
    Modal,
    ResourceUploader,
  },
  data() {
    return {
      code: this.$route.params.code,

      isImportSurvayGroupModal: false,
      dynamicButtons: [
        {
          id: "3",
          name: "delete",
        },
        {
          id: "55",
          name: "edit",
          iconFont: "fas fa-user-plus text-info",
          text: this.$lang.surveyLang.limit_survey_group_parvandeh,
          click: this.showParvandehLimit,
        },
      ],
      parentPermissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["survey", "survey_group_parvandeh"], [this.code]);
    },

    survayGroupImportUploadUrl() {
      return generateApiUrl(["survey", "survayGroupImport"], [this.code]);
    },
    extraButtons() {
      return [
        {
          condition: true,
          title: this.$lang.commenterUpload,
          click: this.handleOpenSurvayGroupImportModal,
          permissions: ["admin", "edit"],
          loading: false,
          iconName: "tray-arrow-up",
        },
      ];
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    getData() {
      this.$refs.parvandeh.getItems();
    },
    updatePermissions(permissions) {
      this.parentPermissions = [...permissions];
    },
    handleCloseSurvayGroupImportModal() {
      this.isImportSurvayGroupModal = false;
    },

    handleOpenSurvayGroupImportModal() {
      this.isImportSurvayGroupModal = true;
    },
    showParvandehLimit(item) {
      const code = this.code;
      const id = pathOr(null, ["id"], item);
      const termId = pathOr(null, ["survey_group_term_id"], item);
      const routeData = this.$router.resolve({
        name: "survey_parvandeh_limit",
        params: { code, id, termId },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
